<template>
    <div v-if="context.marketingGroup" id="selected-network">
        <hp5-label-decorator size="xs" type="heading">
            <p>{{ context.networkName ? context.networkName : selectedNetwork.networkName }}</p>
        </hp5-label-decorator>
    </div>    
</template>

<script setup>
    const { context, networks } = useFCPModel()
    const selectedNetwork = computed(() => networks.value.find((n) => n.safelink == context.value.safelink))
 </script>

<style scoped lang="scss">
    hp5-label-decorator {
        p {
            margin: 0
        }
    }
</style>